import React from "react";

const CategoryThree = () => {
  return (
    <>
      {/* <!-- cta area start --> */}
      <div className="tp-cta-area pt-140">
        <div className="container">
          <div className="tp-cta-wrapper">
            <div className="row">
              <div className="col-12">
                <div className="tp-section-wrapper text-center">
                  <span className="tp-section-subtitle mb-25">
                    Elevate Your Expectations
                  </span>
                  <h2 className="tp-section-title">
                    Advanced Elevator Solutions Designed for <br />
                    Buildings Big and Small
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- cta area end --> */}
    </>
  );
};

export default CategoryThree;
